import { Fragment } from 'react'
import { Formik } from 'formik'
import { useIntl, FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from 'components/v2/Button'
import { Column } from '@10xLabs/react-web/components/Column'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import Heading from 'components/v2/Heading'
import { Input } from 'components/Input'
import { InputNumber } from 'components/InputNumber'
import { Row } from '@10xLabs/react-web/components/Row'
import FormLayout from 'features/App/components/FormLayout'
import { getItemLabel } from 'features/Snacks/components/ItemAutocomplete'
import { getUnprocessableErrors } from 'utils/error'
import { schema } from './schema'

const H6 = styled.h6<TSFixMe>`
  font-size: 14px;
  margin: 0;
`

const ReceiveOrderForm = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const { values, setFieldValue, errors, touched, handleBlur, handleSubmit, error, loading, inventoryId, urls } = props

  return (
    <form autoComplete="off" onSubmit={handleSubmit}>
      <FormLayout.CardContent>
        <Row>
          <Column>
            <Heading.H5>
              <FormattedMessage id="spanish.inventories.receiveBulkItems.form.items.title" defaultMessage="Productos" />
            </Heading.H5>
          </Column>
        </Row>

        {values.items.map((item: TSFixMe, index: TSFixMe): TSFixMe => {
          return (
            <Fragment key={index}>
              <Row>
                <Column>
                  <H6>
                    <FormattedMessage
                      id="spanish.orders.receive.form.item.title"
                      defaultMessage="Producto #{itemCount}"
                      values={{
                        itemCount: index + 1
                      }}
                    />
                  </H6>
                </Column>
              </Row>

              <Row>
                <Column width={`${100 / 3}%`}>
                  <Input
                    value={getItemLabel(item, intl)}
                    label={<FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />}
                    onChange={(): TSFixMe => {
                      // Do nothing
                    }}
                    disabled
                    readOnly
                  />
                </Column>

                <Column width={`${100 / 3}%`}>
                  <InputNumber
                    id="item.ordered"
                    value={item.ordered}
                    onChange={(): TSFixMe => {
                      // Do nothing
                    }}
                    maskOptions={{
                      suffix: '',
                      prefix: '',
                      allowDecimal: false
                    }}
                    label={
                      <FormattedMessage id="spanish.orders.receive.orderedQuantity" defaultMessage="Cantidad enviada" />
                    }
                    disabled
                  />
                </Column>

                <Column width={`${100 / 3}%`}>
                  <InputNumber
                    id={`items[${index}].received`}
                    value={item.received}
                    placeholder="E.g.: 10"
                    onChange={(value: TSFixMe): TSFixMe => {
                      setFieldValue(`items[${index}].received`, value)
                    }}
                    onBlur={handleBlur}
                    touched={touched.items && touched.items[index] && touched.items[index].received}
                    errors={errors.items && errors.items[index] && errors.items[index].received}
                    maskOptions={{
                      suffix: '',
                      prefix: '',
                      allowDecimal: false
                    }}
                    label={
                      <FormattedMessage
                        id="spanish.orders.receive.receivedQuantity"
                        defaultMessage="Cantidad recibida"
                      />
                    }
                  />
                </Column>
              </Row>
            </Fragment>
          )
        })}
      </FormLayout.CardContent>

      <FormLayout.Split />

      <FormLayout.CardFooter>
        {error && (
          <div>
            <ErrorMessage errors={getUnprocessableErrors(error)}>
              <FormattedMessage
                id="spanish.orders.receive.form.error"
                defaultMessage="Hubo un error al guardar la recepción de la orden"
              />
            </ErrorMessage>
          </div>
        )}

        <FormLayout.CardFooterActions>
          <Button
            as={NavLink}
            to={urls.cancelOrder ? urls.cancelOrder : `/inventories/${inventoryId}/pending-orders`}
            kind="cancel"
          >
            <FormattedMessage id="spanish.dictionary.cancel" defaultMessage="Cancelar" />
          </Button>

          <Button type="submit" kind="primary" loading={loading}>
            <FormattedMessage id="spanish.dictionary.save" defaultMessage="Guardar" />
          </Button>
        </FormLayout.CardFooterActions>
      </FormLayout.CardFooter>
    </form>
  )
}

export const ReceiveOrder = ({ order = {}, inventoryId, onSubmit, error, loading, urls = {} }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const initialValues = {
    items: order.lineItems.map((lineItem: TSFixMe): TSFixMe => {
      return {
        id: lineItem.itemID,
        name: lineItem.name,
        units: lineItem.units,
        netContent: lineItem.netContent,
        container: lineItem.container,
        ordered: lineItem.ordered,
        received: ''
      }
    })
  }

  return (
    <Formik initialValues={initialValues} validationSchema={schema(intl)} onSubmit={onSubmit}>
      {(props): TSFixMe => {
        return <ReceiveOrderForm {...props} error={error} loading={loading} inventoryId={inventoryId} urls={urls} />
      }}
    </Formik>
  )
}
